import React from "react";
import { Badge } from "src/components/ui/Badge";
import { formatDateTime } from "src/utils/date-time";

interface MailContentProps {
  request: any;
}

const normalizeStatus = (status?: string) =>
  status?.toString().trim().toLowerCase() || "";

const MailContent: React.FC<MailContentProps> = ({ request }) => {
  if (!request) return null;

  const status = normalizeStatus(
    request?.status || request?.requestStatus || request?.supportStatus || ""
  );

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-start">
        <div>
          <div className="text-sm text-gray-500">From</div>
          <div className="font-medium">
            {request?.name}{" "}
            <span className="text-sm text-gray-500">
              &lt;{request?.email}&gt;
            </span>
          </div>
          {request?.mobile && (
            <div className="text-sm text-gray-500">{request?.mobile}</div>
          )}
        </div>
        <div className="text-sm text-gray-500 text-right">
          <div>
            {formatDateTime(request?.createdAt, "DD MMM YYYY, hh:mm A")}
          </div>
          <div className="mt-2">
            <Badge
              text={(status || "open").toUpperCase()}
              color={status === "closed" ? "green" : "yellow"}
            />
          </div>
        </div>
      </div>

      <div className="border-t pt-4">
        <div className="text-sm font-semibold mb-2">Message</div>
        <div className="whitespace-pre-wrap bg-gray-50 p-4 rounded">
          {request?.message}
        </div>
      </div>
    </div>
  );
};

export default MailContent;
